export type FilmType = 'movie' | 'tv';

export interface CastMember {
  name: string;
  role: string;
}

export interface Film {
  id: string;
  title: string;
  originalTitle: string;
  type: FilmType;
  year: number;
  releaseDate: string;
  region: string;
  language: string;
  genres: string[];
  rating: number;
  popularity: number;
  duration: string;
  poster: string;
  backdrop: string;
  summary: string;
  synopsis: string[];
  cast: CastMember[];
  director: string;
  writers: string[];
  tags: string[];
  updatedAt: string;
}

export const films: Film[] = [
  {
    id: 'chang-ye-xing-he',
    title: '长夜星河',
    originalTitle: 'Stars Over the Long Night',
    type: 'movie',
    year: 2025,
    releaseDate: '2025-09-26',
    region: '内地',
    language: '国语',
    genres: ['科幻', '剧情', '冒险'],
    rating: 8.7,
    popularity: 986,
    duration: '142 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20silhouette%20standing%20before%20a%20vast%20glowing%20nebula%20in%20deep%20navy%20space%2C%20teal%20and%20warm%20amber%20light%20accents%2C%20minimal%20typographic%20space%2C%20dramatic%20atmospheric%20fog%2C%20high%20detail%20cinematic%20composition&width=600&height=900&seq=film-poster-01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20sci-fi%20scene%20of%20a%20vast%20deep%20navy%20starfield%20with%20a%20bright%20cyan%20nebula%20and%20a%20tiny%20spacecraft%20silhouette%2C%20dramatic%20volumetric%20light%2C%20atmospheric%20dust%2C%20dark%20moody%20color%20grade%2C%20film%20still%20composition&width=1600&height=700&seq=film-backdrop-01&orientation=landscape',
    summary: '一次失联七年的深空任务，让一名宇航员在归途中重新面对自己选择离开的理由。',
    synopsis: [
      '2039 年，深空探测器「星河号」在完成第七次跃迁后与地球彻底失联。船员名单里只剩下一个人——领航员林澈。她独自在寂静的舱体里度过了两千多个日夜，靠着重复播放女儿六岁时的录音维持清醒。',
      '影片并没有急于把她送回家。相反，它用大量近乎静默的镜头记录她在空间站里的日常：擦洗同一块舷窗、给早已死去的同伴朗读日志、在失重状态下给女儿写信。这些细碎的仪式感，让漫长的孤独变得可触摸。',
      '当救援船终于出现时，林澈却选择先完成一次计划外的航行——去看看那颗她曾在日志里反复描写的行星。导演用一段长达六分钟无对白的返航镜头，把「回家」重新定义成「先与自己和解」。',
      '结尾处，她落地后第一时间拨通电话，电话那头已经不是记忆里的小女孩。这个反差让整部电影的情绪落到了最真实的地方：时间不会为任何人停下。',
    ],
    cast: [
      { name: '林知夏', role: '林澈' },
      { name: '沈叙白', role: '周衡' },
      { name: '云沛', role: '小满' },
    ],
    director: '程观',
    writers: ['程观', '梁亦寒'],
    tags: ['孤寂', '太空', '亲情', '慢节奏'],
    updatedAt: '2025-10-12',
  },
  {
    id: 'yu-zhong-deng',
    title: '雨中等候',
    originalTitle: 'Waiting in the Rain',
    type: 'movie',
    year: 2024,
    releaseDate: '2024-11-08',
    region: '港台',
    language: '粤语',
    genres: ['爱情', '剧情'],
    rating: 8.2,
    popularity: 812,
    duration: '118 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20Hong%20Kong%20movie%20poster%20of%20two%20figures%20under%20one%20umbrella%20on%20a%20rainy%20neon%20street%20at%20night%2C%20reflections%20on%20wet%20asphalt%2C%20warm%20amber%20streetlamp%20glow%2C%20muted%20teal%20shadows%2C%20soft%20film%20grain%2C%20minimal%20elegant%20composition&width=600&height=900&seq=film-poster-02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Rainy%20Hong%20Kong%20street%20at%20night%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20two%20distant%20silhouettes%20with%20an%20umbrella%2C%20warm%20amber%20and%20deep%20teal%20color%20palette%2C%20cinematic%20bokeh%2C%20moody%20film%20still&width=1600&height=700&seq=film-backdrop-02&orientation=landscape',
    summary: '一家开了三十年的凉茶铺，两个错过又重逢的人，和一整个雨季的等待。',
    synopsis: [
      '故事从一间老旧的凉茶铺开始。老板娘阿珍接手店铺二十年，始终保留着靠窗第二张桌子——那是她年轻时等人常坐的位置。雨季来临时，一个陌生男人每晚都会点同一碗廿四味，坐到打烊。',
      '影片以雨为线索，把九十年代和现在两段时空来回穿插。年轻的阿珍在码头等一个说要一起走的人，成年的阿珍则在雨里目送另一个背影。导演没有给出答案，只是让雨一直落着。',
      '片中大量使用了真实的街巷实景和粤语老歌，潮湿的空气感几乎能透过屏幕传来。第八十分钟那场长达三分钟的长镜头，是整部电影的情感高潮：两个人隔着雨幕，谁都没有先开口。',
    ],
    cast: [
      { name: '陈曼如', role: '阿珍' },
      { name: '黄启堂', role: '阿成' },
      { name: '李沛霖', role: '少年阿珍' },
    ],
    director: '何少棠',
    writers: ['何少棠'],
    tags: ['怀旧', '粤语', '旧街巷', '错过'],
    updatedAt: '2025-10-09',
  },
  {
    id: 'gu-cheng-mi-an',
    title: '古城谜案',
    originalTitle: 'Mystery of the Old City',
    type: 'movie',
    year: 2025,
    releaseDate: '2025-06-20',
    region: '内地',
    language: '国语',
    genres: ['悬疑', '犯罪', '古装'],
    rating: 8.4,
    popularity: 903,
    duration: '126 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20period%20mystery%20film%20poster%20with%20a%20shadowed%20figure%20in%20traditional%20robe%20holding%20a%20lantern%20in%20an%20ancient%20stone%20alley%2C%20deep%20indigo%20night%20tones%2C%20warm%20lantern%20orange%20accent%2C%20floating%20ink%20texture%2C%20dramatic%20moody%20lighting&width=600&height=900&seq=film-poster-03&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20stone%20alley%20at%20night%20with%20red%20lanterns%20and%20fog%20rolling%20through%2C%20deep%20indigo%20shadow%20palette%2C%20one%20warm%20lantern%20glow%2C%20cinematic%20mystery%20film%20still%2C%20high%20detail&width=1600&height=700&seq=film-backdrop-03&orientation=landscape',
    summary: '长安城连续三起离奇命案，追查的捕快发现所有线索都指向十年前的一桩旧案。',
    synopsis: [
      '天宝年间，长安城接连出现三具摆放成特定姿态的尸体，现场都留下一枚磨损的铜钱。新任捕快裴行之被迫接手此案，却发现卷宗里关于十年前同类案件的部分被人整页撕去。',
      '随着调查深入，裴行之走进城西一处废弃的染坊。那里住着一位沉默的画师，他的画里反复出现同一座桥、同一个人。影片用画作与现实的对应关系，构建出一层一层的叙事迷宫。',
      '最终真相并不复杂，但足够刺痛人心：十年前的一场冤案，让一位父亲用最笨拙的方式讨还公道。电影没有为暴力辩护，而是把镜头停在了雪夜里那盏被风吹灭的灯上。',
    ],
    cast: [
      { name: '裴时安', role: '裴行之' },
      { name: '温书擎', role: '画师' },
      { name: '宋知晚', role: '阿绫' },
    ],
    director: '邵仲怀',
    writers: ['邵仲怀', '罗青野'],
    tags: ['古装', '推理', '冤案', '反转'],
    updatedAt: '2025-10-11',
  },
  {
    id: 'hai-an-xian',
    title: '海岸线',
    originalTitle: 'The Coastline',
    type: 'movie',
    year: 2024,
    releaseDate: '2024-08-16',
    region: '日韩',
    language: '日语',
    genres: ['剧情', '家庭'],
    rating: 8.9,
    popularity: 745,
    duration: '131 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Japanese%20family%20drama%20film%20poster%20with%20an%20elderly%20man%20and%20a%20young%20girl%20walking%20along%20a%20quiet%20seaside%20road%2C%20soft%20overcast%20light%2C%20pale%20sand%20and%20muted%20sea%20blue%20tones%2C%20minimal%20quiet%20composition%2C%20gentle%20film%20grain&width=600&height=900&seq=film-poster-04&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Quiet%20Japanese%20seaside%20town%20at%20dusk%20with%20a%20long%20curving%20coastline%2C%20small%20wooden%20houses%2C%20soft%20muted%20blue%20and%20warm%20sand%20tones%2C%20low%20tide%20reflections%2C%20calm%20cinematic%20film%20still&width=1600&height=700&seq=film-backdrop-04&orientation=landscape',
    summary: '退休的渔夫与突然被送来的孙女，在一条漫长的海岸线上重新学习如何相处。',
    synopsis: [
      '妻子去世后，老渔夫和夫独自住在海边的小镇。儿子突然把十岁的女儿送到他这里，说是「工作太忙」。爷孙两人几乎没有共同语言，第一天就为了晚饭吃什么僵持了一整个下午。',
      '影片没有激烈的冲突，只有一件件小事：修渔网、晒鱼干、走三公里去看潮汐表。孙女渐渐发现，爷爷每天清晨都会在同一块礁石上坐十分钟，那是奶奶以前最喜欢的位置。',
      '最动人的一场戏发生在暴雨夜。爷爷冒雨去找走丢的孙女，两人在海岸线的废弃灯塔里躲了一夜。他们第一次说了很多话，也第一次什么都没说，只是并肩看着天黑下去。',
      '结尾孙女回到了城市，但每个月都会寄一张明信片回来。爷爷把它们贴在冰箱上，那一格慢慢被填满。',
    ],
    cast: [
      { name: '中村和夫', role: '和夫' },
      { name: '小林遥', role: '小遥' },
      { name: '佐藤千夏', role: '美咲' },
    ],
    director: '川岛直人',
    writers: ['川岛直人'],
    tags: ['治愈', '祖孙', '海边', '慢生活'],
    updatedAt: '2025-10-06',
  },
  {
    id: 'chen-mo-de-zheng-ren',
    title: '沉默的证人',
    originalTitle: 'The Silent Witness',
    type: 'movie',
    year: 2025,
    releaseDate: '2025-03-14',
    region: '欧美',
    language: '英语',
    genres: ['悬疑', '犯罪', '剧情'],
    rating: 8.1,
    popularity: 688,
    duration: '124 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20featuring%20a%20detective%20silhouette%20in%20a%20dark%20interrogation%20room%2C%20venetian%20blind%20light%20stripes%2C%20deep%20charcoal%20and%20cold%20grey%20palette%20with%20a%20single%20warm%20amber%20lamp%2C%20tense%20minimal%20composition&width=600&height=900&seq=film-poster-05&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Rain%20slicked%20city%20street%20at%20night%20seen%20through%20police%20car%20window%2C%20cold%20grey%20and%20charcoal%20tones%20with%20warm%20amber%20streetlights%2C%20blurred%20traffic%20light%20bokeh%2C%20cinematic%20thriller%20still&width=1600&height=700&seq=film-backdrop-05&orientation=landscape',
    summary: '一个拒绝开口的目击者，一桩看似板上钉钉的案子，让年轻检察官开始怀疑整个系统。',
    synopsis: [
      '一桩地铁站持刀伤人案震动全城，唯一的目击者是一位失语的中年清洁工。所有人都默认他的笔录无足轻重，检方只用十九天就完成了起诉。',
      '年轻检察官艾琳在整理证物时发现了一处时间上的矛盾：监控显示的地铁到站时间，与目击者手势描述的时间差了整整六分钟。这六分钟里发生的事，成了整部电影的谜题。',
      '影片克制地探讨了程序正义与事实真相之间的距离。没有惊悚的追逐，更多是走廊、会议室、档案室里压抑的对话。最后一场法庭戏长达二十分钟，几乎全部依靠演员的眼神完成。',
    ],
    cast: [
      { name: 'Evelyn Hart', role: '艾琳' },
      { name: 'Marcus Reed', role: '米勒' },
      { name: 'David Cho', role: '目击者' },
    ],
    director: 'Nora Whitfield',
    writers: ['Nora Whitfield', 'Sam Doyle'],
    tags: ['法庭', '正义', '反转', '冷色调'],
    updatedAt: '2025-10-03',
  },
  {
    id: 'feng-cong-dong-fang-lai',
    title: '风从东方来',
    originalTitle: 'Wind from the East',
    type: 'movie',
    year: 2023,
    releaseDate: '2023-12-01',
    region: '内地',
    language: '国语',
    genres: ['剧情', '历史'],
    rating: 8.6,
    popularity: 612,
    duration: '156 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Historical%20Chinese%20epic%20film%20poster%20with%20a%20lone%20traveler%20on%20a%20silk%20road%20dune%20at%20sunrise%2C%20warm%20orange%20sand%20tones%20against%20deep%20navy%20sky%2C%20wind%20blown%20fabric%2C%20minimal%20epic%20composition%2C%20high%20detail&width=600&height=900&seq=film-poster-06&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Vast%20silk%20road%20desert%20dunes%20at%20golden%20sunrise%20with%20a%20small%20caravan%20silhouette%2C%20warm%20amber%20sand%20and%20deep%20indigo%20sky%2C%20long%20dramatic%20shadows%2C%20epic%20cinematic%20landscape%20film%20still&width=1600&height=700&seq=film-backdrop-06&orientation=landscape',
    summary: '一支西行的商队在沙漠中走了四个月，他们带去的不是货物，而是一封信。',
    synopsis: [
      '公元七世纪，一支由十二人组成的商队从长安出发，名义上是贩运丝绸，实际上护送一封写给远方使节的信。他们要走的路，是当时地图上都未曾标注的空白。',
      '影片用了大量实景拍摄，沙漠、雅丹、盐湖，每一帧都像画。但真正打动人的，是商队里几个普通人之间的关系：一个想回家的少年、一个不会说汉话的向导、一个始终沉默的女人。',
      '在穿越无人区的第九十天，队伍断水。那场戏没有配乐，只有风声和呼吸声，观众能清晰听见每个人心里的抉择。',
      '他们最终没有走到目的地。信被埋在了一处泉眼旁，商队剩下的人各自返回。影片最后用一段旁白交代：这封信在四百年后被人发现，纸早已腐烂，只剩下封蜡上的纹路。',
    ],
    cast: [
      { name: '贺鸣川', role: '商队首领' },
      { name: '阿依娜', role: '向导' },
      { name: '周舸', role: '少年阿石' },
    ],
    director: '沈砚',
    writers: ['沈砚', '顾星河'],
    tags: ['史诗', '丝路', '群像', '实景'],
    updatedAt: '2025-09-28',
  },
  {
    id: 'xiao-cheng-zhi-ye',
    title: '小城之夜',
    originalTitle: 'Night in a Small Town',
    type: 'movie',
    year: 2024,
    releaseDate: '2024-05-24',
    region: '内地',
    language: '国语',
    genres: ['剧情', '青春'],
    rating: 7.8,
    popularity: 534,
    duration: '107 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Indie%20coming%20of%20age%20film%20poster%20with%20teenagers%20riding%20bicycles%20under%20a%20row%20of%20street%20lamps%20in%20a%20small%20town%20at%20night%2C%20deep%20navy%20sky%2C%20warm%20orange%20lamplight%2C%20soft%20nostalgic%20film%20grain&width=600&height=900&seq=film-poster-07&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Small%20Chinese%20town%20street%20at%20night%20with%20glowing%20street%20lamps%2C%20old%20buildings%2C%20empty%20road%20with%20bicycle%20shadows%2C%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20nostalgic%20cinematic%20still&width=1600&height=700&seq=film-backdrop-07&orientation=landscape',
    summary: '高考结束的那个夏天，四个少年决定在离城之前，把这座小城好好看一遍。',
    synopsis: [
      '小城的高中在七月总是很吵，蝉声、风扇声、还有晚自习后骑车经过小巷的铃声。电影从高考最后一门结束的那个下午开始，讲四个即将各奔东西的少年。',
      '他们约定用一整夜把这座城走完：去废弃的电影院、去河边的高架桥、去那家明天就要关门的书店。路上遇到的每一个人，都在提醒他们这里的生活曾经怎样。',
      '影片没有刻意的告别，也没有煽情的配乐。天亮时，四个人在十字路口分开，谁都没有回头。这种克制，反而比任何一场痛哭都更接近真实的青春。',
    ],
    cast: [
      { name: '林一舟', role: '陈屿' },
      { name: '许澄', role: '夏禾' },
      { name: '方予安', role: '胖子' },
    ],
    director: '姚寻',
    writers: ['姚寻'],
    tags: ['青春', '毕业', '夏夜', '小城'],
    updatedAt: '2025-09-25',
  },
  {
    id: 'chensi-cheng-bao',
    title: '沉沙城堡',
    originalTitle: 'Castle in the Sand',
    type: 'movie',
    year: 2025,
    releaseDate: '2025-01-17',
    region: '欧美',
    language: '英语',
    genres: ['奇幻', '冒险', '家庭'],
    rating: 7.9,
    popularity: 496,
    duration: '113 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20film%20poster%20of%20a%20child%20standing%20before%20a%20giant%20sandcastle%20fortress%20glowing%20at%20twilight%2C%20deep%20navy%20dusk%20sky%20with%20warm%20amber%20lantern%20light%2C%20magical%20atmospheric%20dust%2C%20storybook%20cinematic%20style&width=600&height=900&seq=film-poster-08&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Surreal%20giant%20sandcastle%20fortress%20on%20a%20wide%20beach%20at%20twilight%2C%20tiny%20child%20silhouette%20in%20foreground%2C%20deep%20navy%20dusk%20sky%20with%20warm%20amber%20window%20lights%2C%20magical%20cinematic%20fantasy%20still&width=1600&height=700&seq=film-backdrop-08&orientation=landscape',
    summary: '一个被潮水冲毁的沙堡，在孩子的梦里长成了一座真正的城。',
    synopsis: [
      '八岁的米娅每年夏天都会去海边住两周。她花整个下午堆的沙堡，总在涨潮时被冲走。那年夏天，她在沙滩上睡着，醒来时沙子变成了一座有城墙、有灯笼、有居民的城市。',
      '这座城的规则很奇怪：只要有人真正记住某样东西，它就不会消失。米娅在这里遇到了一个忘记自己名字的守门人，为了帮他，她必须想起自己为什么每年都来这里。',
      '影片的美术设计非常出色，沙子的质感、光影的变化都被处理得细腻温柔。这不是一部刺激的冒险片，更像是一个关于「记住」的童话。',
    ],
    cast: [
      { name: 'Lily Fenn', role: '米娅' },
      { name: 'Owen Barclay', role: '守门人' },
      { name: 'Clara Voss', role: '母亲' },
    ],
    director: 'Julian Marsh',
    writers: ['Julian Marsh', 'Ada Klein'],
    tags: ['童话', '治愈', '海边', '记忆'],
    updatedAt: '2025-09-20',
  },
  {
    id: 'di-shang-zhi-cheng',
    title: '地上之城',
    originalTitle: 'The City Above',
    type: 'tv',
    year: 2025,
    releaseDate: '2025-08-08',
    region: '内地',
    language: '国语',
    genres: ['都市', '剧情', '悬疑'],
    rating: 8.8,
    popularity: 1240,
    duration: '全 32 集',
    poster:
      'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20series%20poster%20of%20a%20woman%20in%20a%20tailored%20coat%20standing%20on%20a%20skyscraper%20rooftop%20overlooking%20a%20glowing%20city%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20amber%20window%20lights%2C%20sleek%20minimal%20composition&width=600&height=900&seq=film-poster-09&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Aerial%20night%20view%20of%20a%20dense%20modern%20Chinese%20city%20skyline%20with%20glowing%20amber%20windows%20and%20deep%20navy%20sky%2C%20light%20fog%20between%20towers%2C%20cinematic%20urban%20series%20still&width=1600&height=700&seq=film-backdrop-09&orientation=landscape',
    summary: '一栋写字楼的停电事故，掀开了这座城市最顶上那层人看不见的交易。',
    synopsis: [
      '第一集从一个极普通的夜晚开始：市中心某栋写字楼突然停电四十分钟，三个不同楼层的人在黑暗里各自经历了一件事。这四个分钟的停顿，成了整部剧集所有矛盾的起点。',
      '剧集采用多线叙事，一条是刚入职的律师助理沈可，一条是握着关键证据的中层管理者，还有一条是看似与整件事无关的物业主管。三条线在前十六集几乎不相交，却在第十七集因为一份快递单交汇。',
      '导演很擅长用空间表达阶层差异：同一栋楼里，顶层的会议室永远开着空调，地下车库的灯坏了三个月没人修。这些细节没有任何台词解释，却让人印象极深。',
      '大结局没有给出简单的正义伸张，而是让每个人为自己相信的东西付出代价。沈可最后离开那栋楼时，回头看了一眼玻璃幕墙上自己的倒影——这个镜头被观众反复讨论。',
    ],
    cast: [
      { name: '苏芷宁', role: '沈可' },
      { name: '陆闻舟', role: '周启明' },
      { name: '何蔚然', role: '许主管' },
    ],
    director: '傅青野',
    writers: ['傅青野', '姜绾'],
    tags: ['职场', '群像', '悬疑', '都市'],
    updatedAt: '2025-10-14',
  },
  {
    id: 'gu-dao-lai-xin',
    title: '孤岛来信',
    originalTitle: 'Letters from the Island',
    type: 'tv',
    year: 2024,
    releaseDate: '2024-10-11',
    region: '港台',
    language: '粤语',
    genres: ['悬疑', '剧情'],
    rating: 8.5,
    popularity: 876,
    duration: '全 12 集',
    poster:
      'https://readdy.ai/api/search-image?query=Mystery%20miniseries%20poster%20of%20a%20lighthouse%20on%20a%20misty%20remote%20island%20at%20dawn%2C%20cold%20blue%20grey%20fog%20with%20a%20warm%20amber%20beam%2C%20lone%20figure%20with%20a%20letter%2C%20quiet%20atmospheric%20composition&width=600&height=900&seq=film-poster-10&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Remote%20misty%20island%20with%20an%20old%20lighthouse%20and%20rough%20sea%2C%20cold%20blue%20grey%20fog%20and%20a%20single%20warm%20amber%20beam%20cutting%20through%2C%20minimal%20moody%20cinematic%20still&width=1600&height=700&seq=film-backdrop-10&orientation=landscape',
    summary: '一个十年没人寄信的孤岛，突然连续收到了七封没有署名的信。',
    synopsis: [
      '岛上只剩十七户人家，邮局每两周来一次船。老邮差阿德负责分拣所有信件，他对每一封信的收发人了如指掌。直到某天，他收到七封没有署名、也没有寄件地址的信，收件人全是同一个人。',
      '这个人早已搬离岛屿十年，房子空着。阿德把信收进抽屉，却又在下一个航次收到了新的一封。剧集由此展开，用十二集的篇幅慢慢揭开这座岛上的旧事。',
      '每一集都会展开一个岛民的故事，看似独立，实则都与十年前那个台风夜有关。摄影非常克制，海雾、潮湿的墙、昏黄的灯光，构成了全片统一的质感。',
      '最后一封信揭晓了答案，也留下了一个温柔的留白：有些话，寄到就够了，不一定需要被读到。',
    ],
    cast: [
      { name: '张国维', role: '阿德' },
      { name: '陈静宜', role: '阿梅' },
      { name: '吴家乐', role: '少年阿德' },
    ],
    director: '林纪南',
    writers: ['林纪南', '谢澄'],
    tags: ['岛屿', '慢悬疑', '书信', '怀旧'],
    updatedAt: '2025-10-13',
  },
  {
    id: 'er-shi-si-xiao-shi',
    title: '二十四小时医院',
    originalTitle: '24H Hospital',
    type: 'tv',
    year: 2025,
    releaseDate: '2025-07-04',
    region: '内地',
    language: '国语',
    genres: ['医疗', '剧情', '职场'],
    rating: 8.3,
    popularity: 1092,
    duration: '全 40 集',
    poster:
      'https://readdy.ai/api/search-image?query=Medical%20drama%20series%20poster%20of%20a%20doctor%20in%20scrubs%20walking%20down%20a%20dim%20hospital%20corridor%20at%20night%2C%20cool%20teal%20grey%20tones%20with%20warm%20amber%20light%20from%20a%20doorway%2C%20clean%20cinematic%20composition&width=600&height=900&seq=film-poster-11&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Empty%20modern%20hospital%20corridor%20at%20night%20with%20soft%20cool%20teal%20lighting%20and%20a%20warm%20amber%20glow%20from%20one%20open%20door%2C%20long%20perspective%2C%20calm%20cinematic%20medical%20series%20still&width=1600&height=700&seq=film-backdrop-11&orientation=landscape',
    summary: '急诊科的夜班从不说晚安。四十集，讲一整年里那些没有名字的四个小时。',
    synopsis: [
      '这部剧把叙事重心放在了「夜班」上。每一集对应急诊科一个夜晚的四个小时，从晚八点到午夜，或者从午夜到凌晨四点。时间被严格限定，观众和医生一起被关在这栋楼里。',
      '主角是一位刚调来的主治医师，她有过一次失败的抢救，因此对每一个决定都异常谨慎。剧集没有把她塑造成天才，而是让她一次次面对两难：床位不够时先救谁，家属不同意时怎么办。',
      '群像是这部剧最大的亮点。护士长、实习生、保安、清洁工，每个人都有自己的故事线，而且都写得足够扎实，没有一个角色只是为了推进剧情存在。',
      '第三十二集那段连续十一分钟的长镜头，从分诊台一直跟到手术室，被很多观众称为年度最震撼的电视画面。',
    ],
    cast: [
      { name: '温知言', role: '医生 叶明霜' },
      { name: '齐岸', role: '医生 高朗' },
      { name: '柳芸', role: '护士长 罗红' },
    ],
    director: '程礼',
    writers: ['程礼', '夏竹', '叶立'],
    tags: ['医疗', '群像', '夜班', '现实'],
    updatedAt: '2025-10-16',
  },
  {
    id: 'chun-feng-lu-guo',
    title: '春风路过旧巷',
    originalTitle: 'Spring Passes the Old Alley',
    type: 'tv',
    year: 2024,
    releaseDate: '2024-03-22',
    region: '内地',
    language: '国语',
    genres: ['家庭', '剧情', '年代'],
    rating: 8.7,
    popularity: 968,
    duration: '全 36 集',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20period%20family%20drama%20poster%20showing%20a%20warm%20old%20alley%20with%20laundry%20lines%20and%20potted%20plants%2C%20two%20generations%20of%20a%20family%20at%20a%20wooden%20doorway%2C%20soft%20warm%20amber%20light%2C%20nostalgic%20film%20grain&width=600&height=900&seq=film-poster-12&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Old%20Chinese%20residential%20alley%20in%20spring%20afternoon%20with%20laundry%20lines%20hanging%20between%20brick%20buildings%2C%20warm%20sunlight%20and%20soft%20green%20shadows%2C%20nostalgic%20cinematic%20series%20still&width=1600&height=700&seq=film-backdrop-12&orientation=landscape',
    summary: '一条老巷子要拆迁了，住在这里三十年的三户人家，各自翻出了压箱底的事。',
    synopsis: [
      '巷子口的拆迁公告贴出来的那个早晨，家家户户都在收拾东西。剧集没有急着讲冲突，而是用前三集的时间，陪这家人过完一个平常的春天：买菜、晾衣、吵架、和好。',
      '三户人家是妯娌、邻居和房东，彼此的关系既亲密又有裂缝。拆迁像一把尺子，把每个人心里那点没说出口的计较都量了出来。',
      '编剧在处理年代线时非常克制，没有刻意的苦难叙事。九十年代和现在的切换都很自然，靠一件旧毛衣、一首歌、一句口头禅完成转场。',
      '结尾全巷子的人一起吃了一顿饭，桌子摆在巷子中间。第二天，推土机来了。',
    ],
    cast: [
      { name: '冯桂兰', role: '大姐 冯桂兰' },
      { name: '许维安', role: '二弟 许维安' },
      { name: '季晓棠', role: '女儿 季晓棠' },
    ],
    director: '杜衡之',
    writers: ['杜衡之', '何柳'],
    tags: ['年代', '家庭', '邻里', '老巷'],
    updatedAt: '2025-10-10',
  },
  {
    id: 'wu-ren-jie-shou',
    title: '午夜接线员',
    originalTitle: 'The Midnight Operator',
    type: 'tv',
    year: 2025,
    releaseDate: '2025-09-19',
    region: '欧美',
    language: '英语',
    genres: ['惊悚', '悬疑'],
    rating: 8.0,
    popularity: 703,
    duration: '全 8 集',
    poster:
      'https://readdy.ai/api/search-image?query=Thriller%20miniseries%20poster%20of%20a%20person%20with%20headphones%20in%20a%20dim%20emergency%20call%20center%2C%20green%20and%20grey%20screen%20glow%20on%20their%20face%2C%20deep%20shadow%2C%20tense%20minimal%20composition&width=600&height=900&seq=film-poster-13&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dark%20emergency%20call%20center%20at%20night%20with%20rows%20of%20empty%20desks%20and%20glowing%20monitors%2C%20cool%20grey%20green%20light%2C%20one%20warm%20lamp%2C%20tense%20cinematic%20thriller%20still&width=1600&height=700&seq=film-backdrop-13&orientation=landscape',
    summary: '急救热线接线员接到一个求救电话，来电者声称自己正在被追杀——而声音属于三年前的她。',
    synopsis: [
      '接线员诺拉在一间只有六个工位的急救中心上夜班。凌晨两点十七分，一个电话打进来，对方喘着气说自己被锁在一间地下室里。诺拉让对方报出地址，听到的却是自己三年前搬离的旧公寓。',
      '八集的篇幅被压缩在同一个夜晚。诺拉一边保持通话，一边在系统里追查号码来源，同时还要处理其他五个真实的求助电话。剧集用极简的场景制造出持续的紧张感。',
      '悬念设置得相当精巧，每集结尾都留一个让人必须看下一集的钩子。但真正让人记住的是诺拉这个角色：她习惯了对陌生人保持冷静，以至于忘了怎么对自己说话。',
      '最后一通电话挂断时，天刚好亮了。这个细节被很多观众称为点睛之笔。',
    ],
    cast: [
      { name: 'Nora Vance', role: '诺拉' },
      { name: 'Ethan Cole', role: '值班主管' },
      { name: 'Ruth Adler', role: '来电者' },
    ],
    director: 'Grace Holloway',
    writers: ['Grace Holloway'],
    tags: ['单夜叙事', '悬疑', '电话', '心理'],
    updatedAt: '2025-10-15',
  },
  {
    id: 'sunset-embers',
    title: '落日餘燼',
    originalTitle: 'Embers at Sunset',
    type: 'tv',
    year: 2023,
    releaseDate: '2023-11-03',
    region: '港台',
    language: '国语',
    genres: ['武侠', '古装', '剧情'],
    rating: 8.4,
    popularity: 721,
    duration: '全 28 集',
    poster:
      'https://readdy.ai/api/search-image?query=Wuxia%20series%20poster%20with%20a%20sword%20wielder%20in%20flowing%20dark%20robe%20standing%20on%20a%20cliff%20at%20sunset%2C%20warm%20orange%20glow%20against%20deep%20indigo%20mountains%2C%20drifting%20petals%2C%20dramatic%20minimal%20composition&width=600&height=900&seq=film-poster-14&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mountain%20cliff%20at%20sunset%20with%20deep%20indigo%20ridges%20and%20warm%20orange%20glow%2C%20mist%20in%20the%20valley%2C%20lone%20figure%20silhouette%2C%20cinematic%20wuxia%20still&width=1600&height=700&seq=film-backdrop-14&orientation=landscape',
    summary: '剑派覆灭十年后，唯一活下来的小师妹带着一柄断剑，重新走回那座山。',
    synopsis: [
      '故事从一场灭门开始。剑派在一夜之间被屠尽，只有十二岁的小师妹被师父塞进密道。十年后，她以另一个名字在江湖上行走，直到听说当年那把断剑出现在山下集市。',
      '剧集的动作设计偏向写实，没有过多的特效和威亚。武打场面强调重量和呼吸感，配合长镜头，让每一场对决都显得疲惫而真实。',
      '情感线上，她与当年仇人的儿子之间有一段复杂的关系。剧集没有把这段关系简单化，而是让两个人都清楚彼此的立场，也因此每一步都走得很艰难。',
      '最后一场戏在雪中的山门前完成，没有赢家。她收起断剑，走下台阶，镜头拉远，整座山安静得像从未发生过任何事。',
    ],
    cast: [
      { name: '叶轻澜', role: '小师妹 沈砚霜' },
      { name: '顾长庚', role: '谢陵' },
      { name: '白无咎', role: '师父' },
    ],
    director: '徐怀山',
    writers: ['徐怀山', '温清'],
    tags: ['武侠', '复仇', '写实武打', '雪景'],
    updatedAt: '2025-10-08',
  },
  {
    id: 'zhong-lou-san-dian',
    title: '钟楼三点',
    originalTitle: 'Three O\u0027Clock at the Bell Tower',
    type: 'movie',
    year: 2025,
    releaseDate: '2025-02-14',
    region: '日韩',
    language: '韩语',
    genres: ['悬疑', '奇幻'],
    rating: 8.0,
    popularity: 468,
    duration: '109 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Mystery%20fantasy%20film%20poster%20of%20an%20old%20European%20style%20clock%20tower%20against%20a%20blue%20hour%20sky%2C%20one%20warm%20lit%20window%2C%20cold%20navy%20and%20amber%20contrast%2C%20minimal%20atmospheric%20composition&width=600&height=900&seq=film-poster-15&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Stone%20clock%20tower%20in%20a%20quiet%20town%20square%20at%20three%20in%20the%20morning%2C%20cold%20deep%20navy%20sky%2C%20warm%20amber%20lamps%2C%20light%20mist%2C%20cinematic%20fantasy%20mystery%20still&width=1600&height=700&seq=film-backdrop-15&orientation=landscape',
    summary: '每天凌晨三点，钟楼会多敲一下。只有一个人听得见。',
    synopsis: [
      '钟表匠的女儿素英发现，镇上那座停摆多年的钟楼，每天凌晨三点都会多响一下。她告诉了所有人，但没有人听见，包括和她睡在同一个房间的妹妹。',
      '她开始记录时间、录音、拍照，都没有结果。影片用大量重复的镜头语言制造出一种轻微的失重感：同一个街角、同一盏路灯、同一辆经过的自行车的影子。',
      '真相与她的童年记忆有关。那座钟楼曾经救过她一命，而这次多出来的一下钟声，也许是一次迟到的回响。影片没有强行解释超自然的部分，而是把重点放在了「相信」这件事上。',
      '结尾素英站在钟楼下，等到三点，钟声响起时她笑了。画面定格，片尾曲是一段老式八音盒的旋律。',
    ],
    cast: [
      { name: '金素英', role: '素英' },
      { name: '朴载勋', role: '钟表匠父亲' },
      { name: '李惠珠', role: '妹妹' },
    ],
    director: '尹在浩',
    writers: ['尹在浩'],
    tags: ['奇幻', '时间', '小镇', '八音盒'],
    updatedAt: '2025-09-22',
  },
  {
    id: 'wai-po-de-lao-an-ban',
    title: '外婆的老案板',
    originalTitle: 'Grandma\u0027s Old Cutting Board',
    type: 'tv',
    year: 2024,
    releaseDate: '2024-06-14',
    region: '内地',
    language: '国语',
    genres: ['美食', '家庭', '治愈'],
    rating: 8.6,
    popularity: 655,
    duration: '全 20 集',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20Chinese%20food%20family%20series%20poster%20of%20an%20old%20wooden%20cutting%20board%20with%20fresh%20vegetables%20and%20steam%20rising%2C%20soft%20amber%20kitchen%20light%2C%20cozy%20nostalgic%20tones%20and%20fine%20texture%20detail&width=600&height=900&seq=film-poster-16&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cozy%20old%20Chinese%20kitchen%20with%20warm%20amber%20evening%20light%20through%20a%20window%2C%20steaming%20wok%2C%20wooden%20shelves%20with%20jars%2C%20nostalgic%20cinematic%20food%20series%20still&width=1600&height=700&seq=film-backdrop-16&orientation=landscape',
    summary: '一家开在老街上的小馆子，一道传承四代的招牌菜，和一群回来了就不想走的人。',
    synopsis: [
      '小馆子没有招牌，只有门口一块旧案板。外婆去世后，孙女辞了城市里的工作回来接手，却发现案板的抽屉里塞满了几十张手写的纸条，每张上面都是一个客人的故事和一道菜。',
      '每一集围绕一道菜展开：番茄炒蛋、红烧肉、雪菜冬笋、梅干菜扣肉。食物拍得非常诱人，但剧集真正讲的是这些菜背后的人：谁回来了，谁离开了，谁一直没走。',
      '剧集节奏很慢，却没有一集让人觉得冗长。老街的烟火气、邻居的闲话、锅里的声音，构成了一个让人想住进去的世界。',
    ],
    cast: [
      { name: '谭爱珍', role: '外婆' },
      { name: '宋雨禾', role: '孙女 宋禾' },
      { name: '老周', role: '隔壁邻居' },
    ],
    director: '贺兰',
    writers: ['贺兰', '沈知味'],
    tags: ['美食', '治愈', '老街', '家庭'],
    updatedAt: '2025-10-05',
  },
  {
    id: 'zui-hou-yi-ban-lie-che',
    title: '最后一班列车',
    originalTitle: 'The Last Train',
    type: 'movie',
    year: 2023,
    releaseDate: '2023-09-08',
    region: '内地',
    language: '国语',
    genres: ['悬疑', '剧情'],
    rating: 7.7,
    popularity: 402,
    duration: '115 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Night%20train%20thriller%20poster%20with%20a%20lone%20passenger%20silhouette%20in%20an%20empty%20illuminated%20carriage%2C%20window%20reflections%20and%20cold%20blue%20night%20outside%20with%20warm%20interior%20lighting%2C%20minimal%20tense%20composition&width=600&height=900&seq=film-poster-17&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Empty%20lit%20train%20carriage%20at%20night%20with%20rows%20of%20blue%20seats%2C%20warm%20overhead%20lighting%2C%20dark%20countryside%20rushing%20past%20the%20windows%2C%20cinematic%20suspense%20still&width=1600&height=700&seq=film-backdrop-17&orientation=landscape',
    summary: '一节车厢只有七个人，但他们每个人的车票上，写的都是同一个名字。',
    synopsis: [
      '末班列车只剩下七名乘客。列车员检票时发现，七张票上的乘客姓名完全相同，而座位号却是连续的。列车在一片没有站名的荒地里临时停车，故事从这里开始。',
      '影片几乎全部在一节车厢里完成，七个陌生人被迫开始交谈。他们逐渐发现彼此之间存在某种联系，而这种联系远比他们想象的沉重。',
      '导演用有限的密闭空间完成了相当精彩的调度，镜头的移动和光线的变化都在暗示角色之间的力量关系。结局并不圆满，但足够公平。',
    ],
    cast: [
      { name: '雷川', role: '列车员' },
      { name: '夏湛', role: '乘客 A' },
      { name: '孟婉', role: '乘客 B' },
    ],
    director: '程观',
    writers: ['梁亦寒'],
    tags: ['密闭空间', '悬疑', '列车', '群像'],
    updatedAt: '2025-09-18',
  },
  {
    id: 'nan-fang-you-xin',
    title: '南方有信',
    originalTitle: 'Letters from the South',
    type: 'tv',
    year: 2025,
    releaseDate: '2025-05-30',
    region: '内地',
    language: '国语',
    genres: ['年代', '爱情', '剧情'],
    rating: 8.2,
    popularity: 588,
    duration: '全 30 集',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20period%20romance%20series%20poster%20of%20a%20young%20woman%20in%20a%20summer%20dress%20holding%20a%20letter%20by%20a%20window%20with%20greenery%20outside%2C%20warm%20filtered%20sunlight%2C%20muted%20green%20and%20amber%20tones%2C%20nostalgic%20film%20grain&width=600&height=900&seq=film-poster-18&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sunlit%20southern%20Chinese%20town%20lane%20with%20old%20whitewashed%20walls%20and%20green%20vines%2C%20warm%20afternoon%20light%2C%20bicycles%20parked%20along%20the%20wall%2C%20nostalgic%20cinematic%20still&width=1600&height=700&seq=film-backdrop-18&orientation=landscape',
    summary: '上世纪八十年代，一对分隔两地的年轻人在通信中相爱，也在通信中走散。',
    synopsis: [
      '故事开始于 1983 年。南方小城的邮局每天下午都有固定的一批信件要分发，她负责抄录地址，他是来取信的技术员。两人从一张写错门牌号的信封开始认识。',
      '剧集的大部分情感推进都靠信件的画外音完成，这让节奏显得格外温柔。那些信里写的事情很小：今天买了什么、天气怎么样、广播里放了一首什么歌。',
      '后半段两人因为一次工作调动失去联系。剧集没有安排戏剧性的重逢，而是让他们在三十年后的一次同学聚会上擦肩而过，彼此都认出来了，但都没有打招呼。',
    ],
    cast: [
      { name: '阮书宁', role: '程南' },
      { name: '闻嘉树', role: '陆行' },
      { name: '柳玉和', role: '邮局老主任' },
    ],
    director: '向晖',
    writers: ['向晖', '苏晚'],
    tags: ['年代', '书信', '八十年代', '错过'],
    updatedAt: '2025-10-07',
  },
  {
    id: 'xing-qiu-ling-que',
    title: '星球零缺',
    originalTitle: 'Planet Zero',
    type: 'movie',
    year: 2024,
    releaseDate: '2024-12-20',
    region: '欧美',
    language: '英语',
    genres: ['科幻', '动作'],
    rating: 7.5,
    popularity: 815,
    duration: '136 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Blockbuster%20sci-fi%20action%20poster%20of%20a%20figure%20in%20tactical%20suit%20standing%20against%20a%20huge%20ringed%20planet%20at%20dusk%2C%20deep%20navy%20atmosphere%20with%20warm%20amber%20rim%20light%2C%20bold%20minimal%20composition&width=600&height=900&seq=film-poster-19&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Alien%20planet%20landscape%20with%20a%20giant%20ringed%20planet%20on%20the%20horizon%2C%20deep%20navy%20sky%2C%20warm%20amber%20dune%20ridges%2C%20tiny%20explorer%20silhouette%2C%20epic%20cinematic%20sci-fi%20still&width=1600&height=700&seq=film-backdrop-19&orientation=landscape',
    summary: '一支勘探队降落在一颗没有生命的星球上，六个月后发现这里其实一直有人。',
    synopsis: [
      '勘探队此行的任务是为期六个月的资源评估。星球表面一片荒芜，大气成分勉强可以呼吸。他们按部就班地采样、建档、回收，直到第三个月，队员发现一组不可能存在的足迹。',
      '影片前半段的节奏非常克制，几乎像一部纪录片。后半段随着发现越来越多，类型元素逐渐介入，动作场面开始出现，但导演始终坚持把「未知」放在第一位。',
      '视觉上最大的看点是那颗巨大的行星，它在不同时间出现在天空的不同位置，成了整部电影的时间刻度。',
    ],
    cast: [
      { name: 'Rhea Lawson', role: '队长' },
      { name: 'Tomas Vega', role: '工程师' },
      { name: 'Ida Norr', role: '生物学家' },
    ],
    director: 'Owen Ramsey',
    writers: ['Owen Ramsey', 'Cody Lin'],
    tags: ['科幻', '探险', '巨行星', '悬疑'],
    updatedAt: '2025-09-30',
  },
  {
    id: 'cha-guan-li-de-ren',
    title: '茶馆里的人',
    originalTitle: 'People in the Teahouse',
    type: 'tv',
    year: 2023,
    releaseDate: '2023-04-07',
    region: '内地',
    language: '国语',
    genres: ['剧情', '年代', '群像'],
    rating: 8.9,
    popularity: 934,
    duration: '全 34 集',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20of%20a%20traditional%20teahouse%20interior%20with%20wooden%20tables%2C%20steam%20and%20warm%20lantern%20light%2C%20several%20seated%20figures%20in%20silhouette%2C%20rich%20amber%20and%20deep%20brown%20tones&width=600&height=900&seq=film-poster-20&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20teahouse%20interior%20with%20wooden%20benches%20and%20paper%20lanterns%2C%20warm%20amber%20daylight%20through%20lattice%20windows%2C%20drifting%20steam%2C%20nostalgic%20cinematic%20period%20series%20still&width=1600&height=700&seq=film-backdrop-20&orientation=landscape',
    summary: '一间开了六十年的老茶馆，从掌柜到伙计，每个人都在这里留下了一段人生。',
    synopsis: [
      '茶馆是老街上最后一个还在用煤炉烧水的地方。掌柜姓陈，第三代人。剧集以茶馆为中心，讲述从上世纪六十年代到今天的几代人故事，每一集都有一位「今天来喝茶的人」。',
      '这部剧最厉害的地方在于，它把宏大的时代变迁都藏在了很小的事情里：茶票怎么变、招牌什么时候换过、谁家的孩子考上了大学。没有任何一句台词在感叹时代，但观众自己能感觉到。',
      '茶馆最后被改成了咖啡馆，但招牌被保留了下来，挂在门口。最后一集，老掌柜坐在新装修的店里喝茶，跟年轻的店长说了一句「茶要趁热」，全剧终。',
    ],
    cast: [
      { name: '陈守拙', role: '老掌柜' },
      { name: '宋庆丰', role: '伙计 老宋' },
      { name: '柳芸', role: '常客 柳老师' },
    ],
    director: '杜衡之',
    writers: ['杜衡之', '温清'],
    tags: ['年代', '群像', '市井', '茶馆'],
    updatedAt: '2025-09-15',
  },
  {
    id: 'hai-shang-hua-yuan',
    title: '海上花园',
    originalTitle: 'Garden at Sea',
    type: 'movie',
    year: 2022,
    releaseDate: '2022-10-21',
    region: '港台',
    language: '粤语',
    genres: ['爱情', '剧情', '文艺'],
    rating: 8.3,
    popularity: 366,
    duration: '121 分钟',
    poster:
      'https://readdy.ai/api/search-image?query=Lyrical%20romance%20film%20poster%20of%20a%20rooftop%20garden%20overlooking%20the%20sea%20at%20golden%20hour%2C%20potted%20plants%20and%20two%20distant%20figures%2C%20soft%20warm%20amber%20and%20muted%20teal%20tones%2C%20delicate%20film%20grain&width=600&height=900&seq=film-poster-21&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sea%20view%20rooftop%20garden%20at%20golden%20hour%20with%20potted%20plants%20and%20wooden%20chairs%2C%20distant%20horizon%20line%2C%20warm%20amber%20sunlight%20and%20muted%20teal%20sea%2C%20lyrical%20cinematic%20still&width=1600&height=700&seq=film-backdrop-21&orientation=landscape',
    summary: '一个在市郊天台种了二十年花的女人，等一个每年只寄一张明信片的人。',
    synopsis: [
      '天台上种满了花，是她一个人打理的。整栋楼的邻居都知道，那个天台不属于任何人，却属于所有人——谁都可以上去坐坐，只要不动那盆白色的花。',
      '影片的时间跨度是二十年，但几乎没有交代中间发生了什么。观众只看到一个个片段：她搬进来、她学着种花、她收到第一张明信片、她在雨里搬花盆。',
      '明信片来自世界各地，没有署名，只有一句「花还好吗」。剧集没有解释寄信人的身份，直到最后一张明信片从同一座城市寄来。',
    ],
    cast: [
      { name: '郑婉清', role: '阿清' },
      { name: '何家俊', role: '天台邻居' },
      { name: '黄静文', role: '花店老板' },
    ],
    director: '林纪南',
    writers: ['林纪南'],
    tags: ['文艺', '花园', '等待', '慢节奏'],
    updatedAt: '2025-09-12',
  },
];

export const regionOptions = ['全部地区', '内地', '港台', '欧美', '日韩'];
export const languageOptions = ['全部语言', '国语', '粤语', '英语', '日语', '韩语'];
export const genreOptionsByType: Record<FilmType, string[]> = {
  movie: ['动作', '爱情', '悬疑', '剧情', '科幻', '犯罪', '奇幻', '家庭', '历史', '冒险'],
  tv: ['都市', '剧情', '悬疑', '家庭', '年代', '医疗', '武侠', '美食', '爱情', '惊悚'],
};
export const yearOptions = ['全部年份', '2025', '2024', '2023', '2022'];

export const typeLabel: Record<FilmType, string> = {
  movie: '电影',
  tv: '电视剧',
};

export function getFilmById(id: string | undefined): Film | undefined {
  return films.find((item) => item.id === id);
}

export function getRelatedFilms(film: Film, count = 6): Film[] {
  const scored = films
    .filter((item) => item.id !== film.id)
    .map((item) => {
      const genreScore = item.genres.filter((g) => film.genres.includes(g)).length * 3;
      const tagScore = item.tags.filter((t) => film.tags.includes(t)).length * 2;
      const regionScore = item.region === film.region ? 1 : 0;
      return { item, score: genreScore + tagScore + regionScore };
    })
    .sort((a, b) => b.score - a.score || b.item.popularity - a.item.popularity);
  return scored.slice(0, count).map((entry) => entry.item);
}

export function searchFilms(keyword: string): Film[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return films
    .filter((item) => {
      const haystack = [
        item.title,
        item.originalTitle,
        item.summary,
        item.director,
        ...item.genres,
        ...item.tags,
        ...item.cast.map((c) => c.name),
      ]
        .join(' ')
        .toLowerCase();
      return haystack.includes(q);
    })
    .sort((a, b) => b.popularity - a.popularity);
}